export enum MyLearningPageContentSections {
  ON_DEMAND = 'on-demand',
  LIVE_TRAININGS = 'live-training',
  CERTIFICATIONS = 'certifications',
  SAVED = 'saved',
  IN_PROGRESS = 'in-progress',
  COMPLETE = 'complete',
  RECENTLY_VIEWED = 'recently-viewed',
}

export const MAX_ITEMS_SHOWN = 5;
